export type MarketSettingsData = {
    assortmentName: string;
    departmentId?: string;
    departmentName?: string;
    marketDate?: Date;
    dueDate?: Date;
    brandContactEmail?: string;
    brandContactName?: string;
    marketStatus?: AssortmentMarketStatus;

    rowCount?: number;
    smuCount?: number;
    totalCost?: string;
    totalRetailValue?: string;
    totalUnits?: number;
    quantityRowsWithUnits?: number;
    totalSized?: number;
    exportCount?: number;
    departmentAndNumbers?: string;
    brandName?: string;
};

export type ErrorMessages<Type> = {
    [Property in keyof Type]?: string;
};

export type MarketSettingsNotifierEvent = (error?: string) => void;

export type SaveAssormentSettingsRequest = MarketSettingsData & {
    onSettled?: MarketSettingsNotifierEvent;
};

export type SaveMarketSettingsEvent = (data: MarketSettingsData, notifier: MarketSettingsNotifierEvent) => void;

export enum AssortmentMarketStatus {
    PENDING_CONFIRMATION = "Pending Confirmation",
    PARTICIPATION_CONFIRMED = "Participation Confirmed",
    POST_MARKET_UPLOAD = "Post Market Upload",
    DECLINED_PARTICIPATION = "Declined Participation",
    LINESHEETS_READY = "Linesheets are Ready",
}
